import { render, staticRenderFns } from "./SoftWareDetail.vue?vue&type=template&id=25285592&scoped=true&"
import script from "./SoftWareDetail.vue?vue&type=script&lang=js&"
export * from "./SoftWareDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoftWareDetail.vue?vue&type=style&index=0&id=25285592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25285592",
  null
  
)

export default component.exports